import React from 'react';
import '../../styles/Dashboard.css';

const Opportunities = () => {
  return (
    <div className="section dashboard-container">
      <p>This is the opportunities page</p>
    </div>
  );
};

export default Opportunities;
